import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const UnitColumns = (props) => {
  const unitColumns: any = [
    {
      name: props.t('unit_name'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: props.t('unit_value'),
      selector: (row) => row.value,
      sortable: true,
      center: true,
    },
    // {
    //   name: props.t('status'),
    //   selector: row => row.status,
    //   sortable: false,
    //   center: true,
    // },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={unitColumns} data={props.data} />;
};
export default translate(UnitColumns);
